import { SettingsNavigationRoot } from "./SettingsNavigationRoot/SettingsNavigationRoot";
import { SettingsNavigationTab } from "./SettingsNavigationTab/SettingsNavigationTab";

export const Root = SettingsNavigationRoot;
export const Tab = SettingsNavigationTab;
